export const FLAGGED_CANCELLATION_LIST_URL_PARAM_KEYS = [
  'search',
  'page',
  'pageSize',
  'sort',
  'flag',
  'appType',
  'policyStatus',
];

export const DEFAULT_FLAGGED_CANCELLATION_LIST_EXTRA_FILTERS = {
  selectedFlg: [],
  selectedAppType: [],
  selectedPolicyStatus: [],
};

export const parseFlaggedCancellationFilters = (searchParams, _paramKey, fallback) => ({
  selectedFlg: searchParams.get('flag')
    ? searchParams.get('flag').split(',').filter(Boolean)
    : fallback.selectedFlg,
  selectedAppType: searchParams.get('appType')
    ? searchParams.get('appType').split(',').filter(Boolean)
    : fallback.selectedAppType,
  selectedPolicyStatus: searchParams.get('policyStatus')
    ? searchParams.get('policyStatus').split(',').filter(Boolean)
    : fallback.selectedPolicyStatus,
});

export const serializeFlaggedCancellationFilters = (filters) => ({
  flag:
    Array.isArray(filters.selectedFlg) && filters.selectedFlg.length > 0
      ? filters.selectedFlg.join(',')
      : '',
  appType:
    Array.isArray(filters.selectedAppType) && filters.selectedAppType.length > 0
      ? filters.selectedAppType.join(',')
      : '',
  policyStatus:
    Array.isArray(filters.selectedPolicyStatus) && filters.selectedPolicyStatus.length > 0
      ? filters.selectedPolicyStatus.join(',')
      : '',
});

export const areArraysEqual = (a = [], b = []) =>
  a.length === b.length && a.every((value, index) => value === b[index]);
